export default __webpack_public_path__ + "static/media/joinnow.c64d5047.svg";